import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import {
  default as Video,
  Controls,
  Play,
  Mute,
  Seek,
  Fullscreen,
  Overlay,
} from 'react-html5video';


class LargeVideoCard extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'LargeVideoCard';

    // if the video is paused
    this.paused = true;
  }


  /**
   * Called when component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    this.node = ReactDOM.findDOMNode(this);
    this.videoElement = this.refs.video;
  }


  /**
   * Called when component props or state updates
   * @param {Object} prevProps - The previous props
   * @returns {undefined} undefined
   */
  componentDidUpdate(prevProps) {
    if (this.node) {
      const state = this.props.largeCardFrameworkState;

      if (state.scrollTop !== prevProps.largeCardFrameworkState.scrollTop) {
        if (((this.node.offsetTop + this.node.offsetHeight)
          - state.scrollTop < 0) || (this.node.offsetTop - state.scrollTop) > window.innerHeight) {
          if (!this.paused) {
            this.paused = true;
            this.refs.video.pause();
          }
        } else {
          if (this.paused) {
            this.paused = false;
            this.refs.video.play();
          }
        }
      }
    }
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const data = this.props.data;
    const style = {
      zIndex: this.props.iteration * 10,
    };
    const gridClass = ' large-col-' + data.largeGridColumns +
      ' large-push-' + data.largeGridPush +
      ' large-top-push-' + data.largeTopPush;
    const className = 'card component-large-video-card' + gridClass;

    return (
      <section
        style={style}
        className={className}
      >
        <div
          className='content'
        >
          <Video
            ref='video'
            controls
            loop
            muted
            poster={data.coverPath}
          >
            <source
              src={data.largePath}
              type='video/mp4'
            />
            <Overlay />
          </Video>
        </div>
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - An array of card React components
 * @prop {Number} iteration - The iteration of the component
 * @prop {Number} largeBreakpoint - The screen width at which the large image
 * size should be shown
 * @prop {Object} largeCardFrameworkState - The state of the
 * LargeCardFramework component
 * @prop {Object} mediaLabCardFrameworkState - The state of the
 * container component
 * @prop {Object} style - A style object
 */
LargeVideoCard.propTypes = {
  data: React.PropTypes.object.isRequired,
  iteration: React.PropTypes.number.isRequired,
  largeCardFrameworkState: React.PropTypes.object.isRequired,
  mediaLabCardFrameworkState: React.PropTypes.object.isRequired,
  style: React.PropTypes.object,
};


export default connect(({ mediaLabCardFrameworkState, largeCardFrameworkState }) =>
  ({ mediaLabCardFrameworkState, largeCardFrameworkState }))(LargeVideoCard);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/cards/large/LargeVideoCard.jsx
 **/